// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.adminTitleSeparator_admin_title_separator__bmXvD {
  padding: 0 30px 20px 30px;
  background-color: #fafbfd;
  height: calc(100% - var(--admin-header-height));
  overflow-y: scroll;
  position: relative;
}
.adminTitleSeparator_admin_title_separator__bmXvD .adminTitleSeparator_title__TcmZZ {
  font-weight: 700;
  font-size: 36px;
  line-height: 1;
  padding: 20px 0 10px;
  letter-spacing: -0.015em;
  text-transform: uppercase;
  color: var(--primary-color);
  margin-bottom: 20px;
  position: sticky;
  top: 0;
  background-color: #fafbfd;
  z-index: 1;
}
@media (max-width: 1440px) {
  .adminTitleSeparator_admin_title_separator__bmXvD .adminTitleSeparator_title__TcmZZ {
    font-size: 34px;
  }
}
@media (max-width: 991px) {
  .adminTitleSeparator_admin_title_separator__bmXvD {
    padding: 20px;
  }
  .adminTitleSeparator_admin_title_separator__bmXvD .adminTitleSeparator_title__TcmZZ {
    font-size: 26px;
  }
}
@media (max-width: 800px) {
  .adminTitleSeparator_admin_title_separator__bmXvD {
    padding: 15px;
    height: calc(100% - var(--admin-header-height-less));
  }
  .adminTitleSeparator_admin_title_separator__bmXvD .adminTitleSeparator_title__TcmZZ {
    font-size: 22px;
  }
}

.adminTitleSeparator_header_wrap__kKqF4 {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.adminTitleSeparator_fade_in__Rb787 {
  animation: adminTitleSeparator_fadeIn__HrhpO 0.3s ease-in forwards;
}

@keyframes adminTitleSeparator_fadeIn__HrhpO {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/AdminPanel/AdminTitleSeparator/adminTitleSeparator.module.scss"],"names":[],"mappings":"AAAA;EACE,yBAAA;EAEA,yBAAA;EACA,+CAAA;EACA,kBAAA;EACA,kBAAA;AAAF;AAEE;EACE,gBAAA;EACA,eAAA;EACA,cAAA;EACA,oBAAA;EACA,wBAAA;EACA,yBAAA;EACA,2BAAA;EACA,mBAAA;EACA,gBAAA;EACA,MAAA;EACA,yBAAA;EACA,UAAA;AAAJ;AAGE;EACE;IACE,eAAA;EADJ;AACF;AAIE;EA7BF;IA8BI,aAAA;EADF;EAGE;IACE,eAAA;EADJ;AACF;AAIE;EArCF;IAsCI,aAAA;IACA,oDAAA;EADF;EAEE;IACE,eAAA;EAAJ;AACF;;AAGA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AAAF;;AAGA;EACE,kEAAA;AAAF;;AAGA;EACE;IACE,UAAA;EAAF;EAEA;IACE,UAAA;EAAF;AACF","sourcesContent":[".admin_title_separator {\n  padding: 0 30px 20px 30px;\n\n  background-color: #fafbfd;\n  height: calc(100% - var(--admin-header-height));\n  overflow-y: scroll;\n  position: relative;\n\n  .title {\n    font-weight: 700;\n    font-size: 36px;\n    line-height: 1;\n    padding: 20px 0 10px;\n    letter-spacing: -0.015em;\n    text-transform: uppercase;\n    color: var(--primary-color);\n    margin-bottom: 20px;\n    position: sticky;\n    top: 0;\n    background-color: #fafbfd;\n    z-index: 1;\n  }\n\n  @media (max-width: 1440px) {\n    .title {\n      font-size: 34px;\n    }\n  }\n\n  @media (max-width: 991px) {\n    padding: 20px;\n\n    .title {\n      font-size: 26px;\n    }\n  }\n\n  @media (max-width: 800px) {\n    padding: 15px;\n    height: calc(100% - var(--admin-header-height-less));\n    .title {\n      font-size: 22px;\n    }\n  }\n}\n.header_wrap {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.fade_in {\n  animation: fadeIn 0.3s ease-in forwards;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"admin_title_separator": `adminTitleSeparator_admin_title_separator__bmXvD`,
	"title": `adminTitleSeparator_title__TcmZZ`,
	"header_wrap": `adminTitleSeparator_header_wrap__kKqF4`,
	"fade_in": `adminTitleSeparator_fade_in__Rb787`,
	"fadeIn": `adminTitleSeparator_fadeIn__HrhpO`
};
export default ___CSS_LOADER_EXPORT___;
